import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const SnowflakeIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M12.546 2a.545.545 0 0 0-1.091 0v2.117l-1.211-.605a.545.545 0 0 0-.488.976l1.699.85v2.836L8.968 9.62 6.503 8.196l.113-1.895a.545.545 0 0 0-1.088-.066l-.082 1.351-1.833-1.058a.545.545 0 1 0-.546.944l1.834 1.06-1.13.745a.545.545 0 1 0 .602.91l1.584-1.046 2.457 1.419.009 2.876-2.466 1.423-1.584-1.046a.545.545 0 0 0-.602.91l1.13.746-1.834 1.059a.545.545 0 1 0 .546.944l1.833-1.058.082 1.35a.545.545 0 0 0 1.088-.065l-.113-1.895 2.456-1.419 2.495 1.431v2.847l-1.698.85a.545.545 0 0 0 .488.975l1.21-.605V22a.546.546 0 0 0 1.091 0v-2.117l1.211.605a.545.545 0 0 0 .488-.976l-1.698-.85v-2.836l2.486-1.446 2.465 1.424-.113 1.895a.546.546 0 0 0 1.088.066l.082-1.351 1.833 1.058a.545.545 0 0 0 .546-.944l-1.834-1.06 1.13-.745a.545.545 0 1 0-.601-.91l-1.585 1.046-2.457-1.419-.009-2.876 2.466-1.423 1.585 1.046a.545.545 0 1 0 .6-.91L19.1 8.53l1.834-1.059a.545.545 0 1 0-.546-.944l-1.833 1.058-.081-1.35a.546.546 0 0 0-1.09.065l.114 1.895-2.456 1.419-2.495-1.431V5.337l1.698-.85a.545.545 0 0 0-.488-.975l-1.21.605V2Zm-3.04 8.57.008 2.876 2.494 1.43 2.487-1.445-.009-2.877-2.494-1.43-2.487 1.445Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
